import { toast } from "react-toastify";

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Text copied to clipboard!");
}
export const usernameChecker = (s) => {
  return (/^[a-zA-Z0-9_]*$/).test(s);
}
